export enum ToastType {
    DEFAULT = "default",
    ERROR = "error",
    WARNING = "warning"
}
